import { createSelector } from "reselect"
import { get, map } from "lodash"
import { getTopicId, getAccount, getExperimentId } from "."

const STEPS = [{
  id: "upload",
  label: "Select Files",
  submitButton: {
    isDisabled: ({ files }) => files.length === 0,
    text: "Scan files",
  },
}, {
  id: "upload/preview",
  label: "Scan Preview",
  submitButton: {
    isDisabled: ({ uploadOption, uploadedFiles, overlappingDates, type }) => {
      if (type === "experiment") return false

      if (overlappingDates.length > 0) {
        return !uploadOption || uploadedFiles.length === 0
      } else {
        return uploadedFiles.length === 0
      }
    },
    text: "Begin upload",
  },
}, {
  id: "upload/complete",
  label: "Upload Complete",
}]

export const getActiveStep = state => get(state, "modules.experimentPositions.activeStep")

export const getSteps = createSelector(
  [getAccount, getTopicId, getExperimentId],
  (account, topicId, experimentId) => {
    if (!topicId) {
      return STEPS
    }
    return map(STEPS, step => ({ ...step, url: `/${account}/t/${topicId}/experiments/${experimentId}/${step.id}` }))
  },
)
